import { request } from "../utils/api";

export const GetTickets = () => {
  return request({
    method: "get",
    baseUrl: "api",
    route: "transaction/history?offset=0&limit=100"
  })
}